import React, { useMemo } from 'react';
import ArrowIcon from '../../../assets/icons/arrow-down.svg';
import MedicalQuestion from './MedicalQuestion';
import Select from '../../BaseComponents/Select';
import CounterComp from './CounterComp';
import { MedicalQuestionResponseElement } from '../../../types/apiGeneratedTypes';

type Props = {
  categoryName: string;
  categoryQuestionsData: MedicalQuestionResponseElement[];
  isExpanded: boolean;
  toggleAccordion: () => void;
};

type CategoryBodySystemsMap = {
  [key: string]: { key: string; value: string }[];
};

const categoryBodySystemsMap: CategoryBodySystemsMap = {
  History: [],
  MOCA: [],
  'PHQ-9': [],
  'Physical Examination': []
};

const SubCategoryAccordion = ({
  categoryQuestionsData,
  categoryName,
  isExpanded,
  toggleAccordion
}: Props) => {
  const [activeQuestion, setActiveQuestion] = React.useState<number | null>(
    null
  );
  const [selectedBodySystem, setSelectedBodySystem] = React.useState({
    key: '',
    value: ''
  });
  const [completedQuestions, setCompletedQuestions] = React.useState<number>(
    categoryQuestionsData?.reduce(
      (acc: number, cur: MedicalQuestionResponseElement) => {
        if (cur.answers.length > 0) {
          return (acc += 1);
        }
        return acc;
      },
      0
    )
  );
  const filteredQuestions = useMemo(() => {
    if (!selectedBodySystem.key) return categoryQuestionsData;
    return categoryQuestionsData.filter((question: any) => {
      return question.body_system === selectedBodySystem.key;
    });
  }, [categoryQuestionsData, selectedBodySystem.key]);

  const filterSelectActionMenuHeight = useMemo(() => {
    return filteredQuestions?.length < 3 ? '94px' : undefined;
  }, [filteredQuestions?.length]);
  return (
    <div
      className='subcategory-accordion'
      style={{
        height: isExpanded ? 'fit-content' : '53px',
        border: isExpanded ? '1px solid #4F9EAD' : undefined
      }}
    >
      <div className='subcategory-accordion-header' onClick={toggleAccordion}>
        <h3>{categoryName}</h3>
        <div className='counter-arrow-container'>
          <CounterComp
            all={categoryQuestionsData?.length}
            completed={completedQuestions}
          />
          <img
            src={ArrowIcon}
            alt=''
            style={{
              transform: isExpanded ? 'rotate(180deg)' : 'rotate(0deg)'
            }}
          />
        </div>
      </div>
      <div className='systems-filter-container'>
        <Select
          title='Filter by Body System'
          isError={false}
          name='body_systems'
          selectedOption={selectedBodySystem}
          onChange={(option) => setSelectedBodySystem(option)}
          placeholder='Select the body system'
          options={categoryBodySystemsMap[categoryName]}
          maxHeight={filterSelectActionMenuHeight}
        />
        {selectedBodySystem.key && (
          <div
            onClick={() => setSelectedBodySystem({ key: '', value: '' })}
            className='filter-btn'
          >
            Clear
          </div>
        )}
      </div>
      <div className='subcategory-accordion-content'>
        {filteredQuestions?.length ? (
          filteredQuestions?.map((question: any) => {
            return (
              <MedicalQuestion
                activeQuestion={activeQuestion}
                setActiveQuestion={setActiveQuestion}
                setCompletedQuestions={setCompletedQuestions}
                questionData={question}
                key={question.id}
              />
            );
          })
        ) : (
          <div style={{ padding: '32px 0' }}>No questions for this system</div>
        )}
      </div>
    </div>
  );
};

export default SubCategoryAccordion;
